(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealSelector = [
    '.seed-hero-banner__content > *',
    '.seed-product-grid__top > *',
    '.seed-product-grid__card',
    '.seed-duo-feature__copy > *',
    '.nevex-insight-zone > header > *',
    '.nevex-insight-zone article',
    '.nevex-reviews__head > *',
    '.nevex-reviews__filters',
    '.nevex-reviews__card',
    '.nevex-pdp__info > *',
    '.nevex-pdp__benefit-card',
    '.nevex-pdp__formula-row',
    '.nevex-pdp__comparison-row',
    '.nevex-quality-certificates > *'
  ].join(',');
  const maskSelector = [
    '.seed-duo-feature__main',
    '.nevex-insight-zone__media',
    '.nevex-pdp__routine-media'
  ].join(',');

  const observe = (root = document) => {
    const revealNodes = [...root.querySelectorAll(revealSelector)].filter((node) => !node.hasAttribute('data-nv-reveal'));
    const maskNodes = [...root.querySelectorAll(maskSelector)].filter((node) => !node.hasAttribute('data-nv-mask'));

    revealNodes.forEach((node, index) => {
      node.setAttribute('data-nv-reveal', 'up');
      node.style.setProperty('--nv-motion-delay', `${Math.min(index % 4, 3) * 70}ms`);
    });
    maskNodes.forEach((node) => node.setAttribute('data-nv-mask', ''));

    const targets = [...revealNodes, ...maskNodes];
    if (!targets.length) return;
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      targets.forEach((node) => node.classList.add('nv-is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('nv-is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -9% 0px', threshold: .08 });
    targets.forEach((node) => observer.observe(node));
  };

  let revealFallbackTicking = false;
  const revealVisibleFallback = () => {
    if (revealFallbackTicking) return;
    revealFallbackTicking = true;
    window.requestAnimationFrame(() => {
      document.querySelectorAll('[data-nv-reveal], [data-nv-mask]').forEach((node) => {
        if (node.classList.contains('nv-is-visible')) return;
        const rect = node.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight * .96) node.classList.add('nv-is-visible');
      });
      revealFallbackTicking = false;
    });
  };

  const init = () => {
    document.documentElement.classList.add('nv-motion-ready');
    observe();
    revealVisibleFallback();
    window.addEventListener('scroll', revealVisibleFallback, { passive: true });
    window.addEventListener('resize', revealVisibleFallback, { passive: true });
    window.addEventListener('pageshow', revealVisibleFallback);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
